<template>

  <div class="white-bg" style="padding: 10px; min-height: 100vh">

    <p class=MsoNormal style='text-align:justify'><a name="_GoBack"></a><b><span style='font-family:Arial'>TERMS OF USE
        </span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>The
        following terms and conditions constitute an agreement between you and PARKAIDE
        MOBILE (M) SDN BHD (Company No. 824592D ("PARKAIDE" "we" or "our" or "us"), the
        operator of PARKBILLS (the "Platform") which is a <span lang=EN-MY>season pass
          account management system </span>(the "Services"). These terms of use ("Terms
        of Use"), together with our Personal Data Protection Notice located at the Platform
        (which is incorporated herein by reference, and collectively, this "Agreement")
        govern your use of the Platform and the Services.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>By
        using or otherwise accessing the Platform and the Services, you agree to the
        terms of this Agreement. If you do not agree with any term in this Agreement,
        you must refrain from accessing or using the Platform and the Services. Please
        note that we offer the Platform and the Services &quot;AS IS&quot; and without
        warranties. You are required to register and authorize the use and disclosure
        of your information for purposes of allowing us to provide the Services and as
        otherwise disclosed in our Personal Data Protection Notice.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>1.
          SERVICES</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>The
        Services is an online platform which enables you as: (i) a car park operator ("Service
        Provider") to offer your season parking products to car park users ("Customer");
        or (ii) a Customer to apply and pay for season parking products offered by the Service
        Provider. </span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>If
        you are a Customer using our Services, you understand and acknowledge that the season
        parking products and services available on the Platform are provided by the
        Service Provider. From the point at which you submit your information on the Platform,
        we act solely as an intermediary between you and the Service Provider,
        transmitting the details of your application and payment to the relevant Service
        Provider and sending you a confirmation email for and on behalf of the Service Provider.
        You authorise us to release the details of your application and payment made
        through the Services to the Service Provider. A link provided to the Service Provider"s
        terms and conditions of use and/or privacy policy will govern the relationship
        between you and the Service Provider for the relevant products and/or services
        provided by the Service Provider. </span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>If
        you are a Service Provider using our Services, you understand and acknowledge
        that we act solely as an intermediary between you and the Customer. You shall
        ensure that your relationship with the Customer for the relevant products
        and/or services provided by you is governed by a separate terms and conditions
        of use and/or privacy policy.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        reserve the right to suspend and/or terminate your account at any time which
        will result in your inability to use the Platform and/or the Services. </span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>2.
          CONTENT </span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>If
        you are a Customer using our Services, you acknowledge that <span lang=EN-MY>the
          Content that we disclose is based on the information provided to us by third
          parties including the </span>Service<span lang=EN-MY> Provider </span>and do
        not constitute an opinion or advice, nor is it a substitute for the same. The
        Content is provided solely to assist you with identifying a Service Provider
        for your parking needs. "Content" means design, text, data, graphics, images, user
        interface, visual interface, information, suggestions, guidance, and other
        materials provided, made available or otherwise found through the Platform
        and/or the Services including without limitation Content provided in direct
        response to your questions or postings. Your use of the Content is solely at
        your own risk. </span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        may, but have no obligation to have the Content posted through the Platform
        and/or the Services reviewed by our editorial personnel. It is important to
        note, however, that the timeliness, accuracy, and completeness of any or all of
        the Content are not guaranteed. We will not be responsible for any errors or
        omissions or for the results obtained from the use of such Content. <span lang=EN-MY>Each </span>Service <span
          lang=EN-MY>Provider remains responsible at
          all times for the accuracy, completeness and correctness of the Content displayed
          on the Platform.</span></span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>3.
          NO WARRANTIES IN RELATION TO THE SERVICE PROVIDER</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>If
        you are a Customer using our Services, the Service Provider listed in the Platform
        to which you may make an application with enter into contracts with us for the Services
        we provide to them through the Platform. Notwithstanding the foregoing, we do
        not: (1) recommend or endorse any Service Provider listed in the Platform and (2)
        make any representations or warranties with respect to these Service Providers or
        the quality of the customer services they may provide. <span lang=EN>You are
          required to do your own checks and verification on the third party products and
          services and the relevant </span>Service <span lang=EN>Provider. </span>We have
        no control over and cannot guarantee the availability or credibility of the Service
        Provider at any particular time. We will not be liable for cancelled or
        otherwise unfulfilled applications, or any injury resulting therefrom, or for
        any other injury resulting or arising from or related to the use of the Platform
        and/or the Services.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        use reasonable efforts to ensure that the Service Provider hold all current
        licenses required by law to operate in the country. The Service Provider shall be
        solely responsible for all losses or damages incurred or suffered by you
        arising out of or in connection with your application with the Service Provider
        or from any goods or services of the Service Provider. </span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>Any
        outstanding charges in respect of your application or related services rendered
        by the Service Provider will be entirely your responsibility. You must resolve
        any dispute, including without limitation payment and refund, between you and
        the Service Provider arising from any transaction hereunder directly with the Service
        Provider.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>&nbsp;</span></b></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>4.
          REGISTRATION </span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>As
        part of the registration process, you are required to provide your name, email
        address, phone number and create a password. These are your registration
        details for accessing the Services that are only available to users (&quot;Registration
        Details&quot;). The Registration Details must be kept confidential at all times
        and must not be disclosed to anyone else. You must immediately notify us if
        your password has been stolen or compromised by sending an email to service@parkaidemobile.com.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>You
        must be 18 years of age or over to register with us or use the Platform and/or the
        Services. If you do not qualify under these Terms of Use, do not use the Platform
        and/or the Services. By using the Platform and/or the Services, you represent
        and warrant that you have the right, authority, and capacity to enter into
        these Terms of Use and to abide by all of the terms and conditions set forth
        herein.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>5.
          USER OBLIGATIONS</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>By
        registering for access to the Platform and use of the Services, you agree to
        abide by the following terms and conditions: (1) you may only use the Platform
        and/or the Services for lawful, non-commercial, personal purposes and not for
        any purpose that is illegal or prohibited by these Terms of Use; (2) you are
        responsible for protecting the safety and security of any computer, mobile
        phone and/or any other equipment and/or hardware you use to access the Platform
        and/or the Services; (3) you will not post or transmit any material or
        information which is offensive, defamatory, obscene, unlawful, vulgar, harmful,
        threatening, abusive, harassing or ethnically objectionable; (4) you may not
        attempt to gain unauthorized access to any of the Services, user accounts,
        computer systems or networks through hacking, password mining or any other
        means; (5) you agree to provide current, accurate and up-to-date information
        about yourself as required under these Terms of Use; (6) you agree not to post
        or transmit any unsolicited advertising or promotional materials; (7) <span lang=EN-MY>you will not infringe
          our intellectual property rights or those of
          any third party in relation to your use of the Platform and/or the Services</span>;
        (8) you will not post or transmit any material which contains viruses or other
        computer codes, files or programs which are designed to limit or destroy the
        functionality of other computer software or hardware; and (9) you accept that
        any information provided by us is general information and is not in the nature
        of advice. We derive our information from sources which we believe to be
        accurate and up to date as at the date of publication and reserve the right to
        update this information at any time.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>Any
        information which you transmit to us is transmitted at your own risk.&nbsp;
        Nevertheless, once we receive your transmission, we will take reasonable steps
        to preserve the security of such information.&nbsp; We reserve the right to
        remove your username or similar identifier in respect of your account if
        appropriate.&nbsp; You acknowledge sole responsibility for and assume all risk
        arising from your access and use of the Platform and/or the Services. </span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>&nbsp;</span></b></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>6.
          YOUR PERSONAL INFORMATION</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        collect and process your personal data in accordance with the Personal Data
        Protection Notice at the Platform and you hereby consent to the processing of
        your personal data in accordance with the said notice.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>&nbsp;</span></b></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>7.
          CHANGES TO THE SERVICES</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        may from time to time add new services to the Services, substitute a new
        service for one of the existing Services, discontinue or suspend one of the
        existing Services. The use of new services will be governed by this Agreement.
        You agree that PARKAIDE will not be liable to you or any third party for any
        suspension or discontinuation of any of the Services or portion thereof.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>It
        may be necessary for us to perform scheduled or unscheduled repairs or
        maintenance, or remotely patch or upgrade the Platform and/or the Services,
        which may temporarily degrade the quality of the Services or result in a
        partial or complete outage of the Services.&nbsp; In this regard, we will not
        be liable to you or any third party for any such degradation in the quality or
        outage of the Services.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>&nbsp;</span></b></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>8.
          CONTENT YOU POST OR SUBMIT</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>You
        may have in the future the opportunity to submit reviews regarding your
        experiences with the Service Provider featured through the Services, to submit
        inquiries concerning possible parking needs, to participate in the other
        interactive and community features of the Platform (collectively "Posted
        Information"). It is important that you act responsibly when providing Posted
        Information and you shall at all times comply with the above section on User
        Obligations. </span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        reserve the right to investigate and take appropriate legal action against
        anyone who breaches this provision or the above section on User Obligations,
        including without limitation, removing any offending communication from the Platform
        and/or the Services and terminating the account of such violators or blocking
        your use of the Platform and/or the Services.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>By
        posting Posted Information through the Platform and/or the Services, you agree
        to and hereby do grant, and you represent and warrant that you have the right
        to grant to us and our contractors an irrevocable, perpetual, royalty-free,
        fully sublicensable, fully paid up, worldwide license to use, copy, publicly
        perform, digitally perform, publicly display, distribute such Posted
        Information to adapt, edit, translate, prepare derivative works of, or
        incorporate into other works, such Posted Information. We reserve the right to
        adjust, refuse or remove the Posted Information at our sole discretion.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>9.
          INTELLECTUAL PROPERTY RIGHTS</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>Copyright
        in the Platform, the Services and the Content (including designs, texts,
        graphics, logos, icons, user interfaces, visual interfaces and software) is
        owned or licensed by us <span lang=EN>and/or our third party licensors</span>.
        You acknowledge that the Platform, the Services and any underlying technology
        or software used in connection with the Platform and the Services contain the
        proprietary information of PARKAIDE and/or its third party licensors. We give
        you permission to use the Platform, the Services and the Content for personal,
        non-commercial purposes only and do not transfer any intellectual property
        rights to you by virtue of permitting your use of the Platform and/or the Services.&nbsp;
        Except as expressly authorised by these Terms of Use, you may not in any form
        or by any means: (1) adapt, reproduce, store, distribute, print, display,
        perform, publish or create derivative works from any part of the Platform
        and/or the Services; (2) commercialise any information, products or services
        obtained from any part of the Platform and/or the Services; (3) modify,
        sublicense, translate, sell, reverse engineer, decipher, decompile or otherwise
        disassemble any portion of the Platform and/or the Services or use any part of
        the same to provide or incorporate into, any product of service provided to a
        third party; or (4) downloading or storing the Content. Subject to the
        foregoing restrictions, we grant you a non-exclusive, non-transferable,
        revocable license to use the Platform solely for your permitted use of the
        Services.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>If
        you use any of PARKAIDE" or our third party licensor"s trademarks, rights in internet
        domain names and website addresses and other rights in trade names ("Marks") in
        reference to our activities, products or services, you must include a statement
        attributing the Marks to us.&nbsp; You must not use any of the Marks: (1) in or
        as the whole or part of your own trademarks; (2) in connection with activities,
        products or services which are not ours; (3) in a manner which may be
        confusing, misleading or deceptive; and/or (4) in a manner which disparages us
        or our information, products or services (including the Services).</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>10.
          LINKS TO OTHER SITES</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>The
        Platform and/or the Services may contain links to other websites ("Linked Websites").&nbsp;
        Such links are provided for convenience only and may not remain current or be
        maintained.&nbsp; We are not responsible for the content or privacy practices
        associated with the Linked Websites.&nbsp; The Linked Websites should not be
        construed as an endorsement, approval or recommendation by us of the owners or
        operators of those Linked Websites, or of any information, graphics, materials,
        products or services referred to or contained on those Linked Websites, unless
        and to the extent stipulated to the contrary.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>11.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          PROHIBITED
          ACTIVITIES</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        may (but shall be under no obligation to) investigate if you have misused the Platform
        and/or the Services, or behave in a way, which we regard as inappropriate,
        unlawful or illegal. The following is a non-exhaustive list of prohibited
        activities which you shall not engage in with respect to the Platform and/or
        the Services. We reserve the right to amend this list at any time. The
        prohibited activities include, without limitation: (1) impersonating any person
        or entity, falsely state or otherwise misrepresent your affiliation with any
        person or entity in connection with the Platform; (2) expressing or implying
        that any statements you make are endorsed by us without our specific prior
        written consent; (3) using any robot, spider, or other device or process to
        retrieve, index, or in any way reproduce or circumvent the navigational
        structure or presentation of the Platform and/or the Services; (4)
        &quot;frame&quot; or &quot;mirror&quot; any part of the Platform and/or the
        Services, without our prior written authorization; (5) using any code or other
        devices containing any reference to us, the Platform and/or the Services to
        direct persons to any other website and/or service; (6) using the content
        contained in the Platform and/or the Services for any illegal, fraudulent or
        harmful purpose; (7) using the Platform and/or the Services in any manner that
        could damage, disable, overburden, impair the operation of the Platform, the
        Services, our servers or networks, or interfering with any other party's use
        and enjoyment of the Platform and/or the Services, or violate any requirements,
        procedures, policies or regulations of such networks; (8) violating any laws; (9)
        publicly disseminate information regarding the performance of Platform and/or the
        Services or access or use the Platform and/or the Services for competitive
        analysis or benchmarking purposes.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>12.
          DISCLAIMER </span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>You
        release us from all liability for you having acquired or not acquired the Content
        through the Platform and/or the Services. We make no representations concerning
        any Content contained in or accessed through the Platform and/or the Services,
        and we will not be responsible or liable for the accuracy, copyright
        compliance, legality or decency of material contained in or accessed through the
        Platform and/or the Services. &nbsp;We make no representations or warranties
        regarding suggestions or recommendations or endorsements of services or
        products offered or purchased through the Platform and/or the Services. </span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>Save
        and except for any implied warranties which cannot be contracted out by law, we
        hereby disclaim all warranties, with respect to the Platform and the Services<span lang=EN-MY>, including
          without limitation any warranties that the Platform and
          the Services are merchantable, of satisfactory quality, accurate, fit for a
          particular purpose or need</span>. We do not guarantee that you will be able to
        access or use the Platform and the Services (either directly or through
        third-party networks) at times or locations of your choice.&nbsp; We are not
        responsible for the accuracy, reliability, timeliness or completeness of
        information provided by users of the Platform and/or the Services or any other
        data or information provided or received through Platform and/or the Services.
        Except as expressly set forth herein we make no warranties about the Services
        or any other security associated with the transmission of sensitive
        information. We do not warrant that the Platform and/or the Services will
        operate error-free, bug-free or free from defects, that loss of data will not
        occur, or that the Platform and/or the Services are free of computer viruses,
        contaminants or other harmful items.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>Notwithstanding
        anything contained herein, if you are dealing as a consumer under the Consumer
        Protection Act 1999 ("Act") (consumer shall have the meaning prescribed to it
        by the Act, "Consumer"):&nbsp; (1) we give you such implied warranties under
        the Act that cannot be excluded by the Act; (2) these Terms of Use are only
        intended to exclude or limit the remedies and rights you may have under the Act
        to the maximum extent permitted by law; and
        (3)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; nothing
        in these Terms of Use are intended to exclude or limit our liability to you for
        any loss or damage arising from the negligence on our part or breach of any
        express terms contained herein or implied by any applicable law, including the
        Act which cannot be excluded by law.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>Save
        and except for the foregoing, these Terms of Use shall apply to all users of
        the Platform and/or Services.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>13.
          LIMITATION OF LIABILITY</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>In
        no event shall we be liable to you (or to any third party claiming under or
        through you) for any loss or damages howsoever arising, including without
        limitation, any indirect, special, incidental, consequential or exemplary
        damages arising from your use of, or inability to use the Platform and/or the Services.
        These exclusions apply to any claims for lost profits, lost data, loss of
        goodwill, computer failure or malfunction, any other commercial damages or
        losses even if we knew or should have known of the possibility of such damages.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>In
        no event shall our total cumulative liability to you for any and all claims
        relating to or arising out of your use of the Platform and/or the Services
        regardless of the form of action, exceed the license fee paid by you pursuant
        to the Parking License Agreement Terms and Conditions.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>14.
          INDEMNIFICATION</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>You
        agree to indemnify us against any loss, damage or cost incurred by us arising
        out of your access or use of the Platform, including, without limitation, the
        Services, the Content or any other information accessible over or through the Platform
        and/or the Services, any content submitted by you or your violation of these
        Terms of Use, or any other laws, regulations and rules. You will also indemnify
        us against any claims that information or material which you have submitted to
        us is in violation of any law or in breach of any third party rights
        (including, but not limited to, claims in respect of defamation, breach of
        confidence, infringement of copyright or infringement of any other intellectual
        property right).</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>&nbsp;</span></b></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>15.
          TERMINATION </span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        may terminate and/or suspend your registration immediately, without notice, if
        there has been a breach of this Agreement or other policies and terms posted on
        the Platform or through the Services by you or by someone using your Registration
        Details. We may also cancel or suspend your registration for any other reason,
        including inactivity for an extended period. We shall not be liable to you or
        any third party for any termination of your access to the Platform and/or the
        Services. Further, you agree not to attempt to use the Platform and/or the
        Services after any such deletion, deactivation or termination (provided, in the
        case of deactivation due exclusively to your inactivity, you may be permitted
        to re-register). Notwithstanding anything contained in this Agreement, any provisions
        of this Agreement which are capable of having effect after the termination of your
        registration shall remain in full force and effect following the termination of
        your registration.</span></p>

    <span style='font-size:11.0pt;line-height:115%;font-family:Arial'><br clear=all style='page-break-before:always'>
    </span>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>16.
          GENERAL</span></b></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>17.1
          Amendments to These Terms of Use</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>We
        reserve the right to amend these Terms of Use and the other documents
        consisting of the Agreement at any time. Upon any such change, we will post the
        amended terms on the Platform or we may also attempt to notify you via
        electronic or conventional mail. Your continued access to and/or use of the Platform
        the Services following such posting and/or notice shall constitute your agreement
        to be bound by these Terms of Use or other applicable Agreement document, as
        amended. &nbsp;If at any time you choose not to accept these Terms of Use,
        including following any such modifications hereto, then you must stop using the
        Platform and/or the Services.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>17.2
          Severability</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>If
        any of these Terms of Use are held to be invalid, unenforceable or illegal for
        any reason, the remaining terms and conditions shall nevertheless continue in
        full force.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>17.3
          Governing Law</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>This
        Agreement shall be governed by the laws of Malaysia and the courts of Malaysia
        shall have exclusive jurisdiction.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>17.4
          Non-waiver</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>Our
        failure to exercise or enforce any right or provision of this Agreement shall
        not constitute a waiver of such right or provision. The failure of either party
        to exercise in any respect any right provided for herein shall not be deemed a
        waiver of any further rights hereunder.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>17.5
          Entire Agreement</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>This
        Agreement and any supplemental terms, policies, rules and guidelines posted
        through the Platform and/or the Services, including the Personal Data
        Protection Notice, constitute the entire agreement between you and us and
        supersede all previous written or oral agreements. </span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>17.6
          Headings</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>The
        headings in this Agreement are for convenience only, do not form a part hereof,
        and in no way limit, define, describe, modify, interpret or construe the
        meaning, scope or intent of this Agreement or any terms or conditions therein.</span></p>

    <p class=MsoNormal style='text-align:justify'><b><span style='font-family:Arial'>17.7
          Non-assignment</span></b></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>You
        may not assign, transfer or sublicense this Agreement to anyone else and any
        attempt to do so in violation of this section shall be null and void.</span></p>

    <p class=MsoNormal style='text-align:justify'><span style='font-family:Arial'>&nbsp;</span></p>

  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageTnc",
  data(){
      return {
      }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
  },
  methods : {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageTnC.vue